<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <topo-graph-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></topo-graph-form>
  </j-modal>
</template>

<script>

  import TopoGraphForm from './TopoGraphForm'
  export default {
    name: 'TopoGraphModal',
    components: {
      TopoGraphForm
    },
    data () {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      copy(record){
        this.visible = true
        this.$nextTick(() => {
          record.topoName="";
          record.processId="";
          this.$refs.realForm.copy(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>